import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import { DateTime } from 'luxon';
import { toDateTime } from '../../../utils/date-time';

@Pipe({ name: 'isToday', pure: true })
export class AppIsToday implements PipeTransform {
    transform(value: string | DateTime, format?: string): any {
        const instance = toDateTime(value);

        if (instance?.isValid) {
            return instance.hasSame(DateTime.local(), 'day');
        }

        return false;
    }
}
